module.exports = __webpack_public_path__ + "static/media/not-found-img.bfb19519.svg";